import { render, staticRenderFns } from "./JeecgOrderMainListForJEditableTable.vue?vue&type=template&id=70b2f0be&scoped=true&"
import script from "./JeecgOrderMainListForJEditableTable.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderMainListForJEditableTable.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderMainListForJEditableTable.vue?vue&type=style&index=0&id=70b2f0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2f0be",
  null
  
)

export default component.exports